<template>
    <div id="price-periods-section" class="periods tabulation-title">
        <div>
            <h5 class="price-period-tab" :style="'color:' + titlesColor">
                {{ index }}.
                <span v-if="!newTitle">
                    Tarifs
                </span>
                <span v-else>
                    {{newTitle}}
                </span>
            </h5>
        </div>

        <v-alert type="info"
                 class="mb-5 form-container mr-auto ml-auto"
                 border="right"
                 :color="primaryColor"
                 colored-border
                 v-if="helpDesc"
        >
            <div>{{helpDesc}}</div>
        </v-alert>

        <div class="form-container mr-auto ml-auto mt-3">
            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import FormComponentLoader from "../FormComponentLoader.vue"

export default {
    name: "PricePeriods",
    components: {FormComponentLoader},
    props: ['index', "newTitle", "helpDesc"],
    computed: {
        ...mapState('webFormStyle', ['titlesColor', 'primaryColor']),
        ...mapGetters('web_form', ['getFieldsFromTabulation']),
        tabulationFields() {
            return this.getFieldsFromTabulation('TARIF').sort((a, b) => a.order - b.order)
        }
    }
}
</script>